import axios from "axios";

export const serverInstance = axios.create({
  baseURL: "https://api.portal.tomko.mn",
  headers: {
    'Accept': 'application/json',
    "Content-type": "application/json; charset=UTF-8",
  },
});

export const adminServerInstance = axios.create({
  baseURL: "https://api.admin.tomko.mn",
  headers: {
    'Accept': 'application/json',
    "Content-type": "application/json; charset=UTF-8",
  },
});